import { CustomShaderBlock } from "./customShaderBlock.js";
/**
 * Serializes a CustomShaderBlock to V1 serialized data.
 * @param block - The block to serialize
 * @returns The serialized block
 */
export const CustomShaderBlockSerializer = (block) => {
    if (block.getClassName() !== CustomShaderBlock.ClassName) {
        throw new Error("Was asked to serialize an unrecognized block type");
    }
    const customShaderBlock = block;
    let data;
    const dynamicPropertyNames = customShaderBlock.dynamicPropertyNames;
    if (dynamicPropertyNames.length > 0) {
        data = {
            customProperties: dynamicPropertyNames.map((propertyName) => ({
                name: propertyName,
                value: customShaderBlock[propertyName],
            })),
        };
    }
    return {
        name: customShaderBlock.name,
        uniqueId: customShaderBlock.uniqueId,
        blockType: customShaderBlock.blockType,
        namespace: customShaderBlock.namespace,
        comments: customShaderBlock.comments,
        data,
        outputTextureOptions: customShaderBlock.outputTextureOptions,
    };
};
//# sourceMappingURL=customShaderBlock.serializer.js.map